import { render, staticRenderFns } from "./WizardCheckout.vue?vue&type=template&id=36667ede&scoped=true&"
import script from "./WizardCheckout.vue?vue&type=script&lang=js&"
export * from "./WizardCheckout.vue?vue&type=script&lang=js&"
import style0 from "./WizardCheckout.vue?vue&type=style&index=0&id=36667ede&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36667ede",
  null
  
)

export default component.exports